// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fi-document-template-item-options-image {
  display: block;
}
fi-document-template-item-options-image .template-image-options .no-image {
  margin-bottom: 10px;
}
fi-document-template-item-options-image .template-image-options .existing-image {
  text-align: center;
}
fi-document-template-item-options-image .template-image-options .existing-image img {
  max-width: 100%;
  max-height: 240px;
}
fi-document-template-item-options-image .template-image-options .FileUploadContainer {
  width: auto;
}
fi-document-template-item-options-image .template-image-options .button-block {
  margin: 0 30px;
}`, "",{"version":3,"sources":["webpack://./Source/app/document-template/document-template-item-options/document-template-item-options-image/document-template-item-options-image.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;AAGQ;EACI,mBAAA;AADZ;AAIQ;EACI,kBAAA;AAFZ;AAIY;EACI,eAAA;EACA,iBAAA;AAFhB;AAMQ;EACI,WAAA;AAJZ;AAOQ;EACI,cAAA;AALZ","sourcesContent":["fi-document-template-item-options-image {\r\n    display: block;\r\n    //padding: 16px;\r\n\r\n    .template-image-options {\r\n        .no-image {\r\n            margin-bottom: 10px;\r\n        }\r\n\r\n        .existing-image {\r\n            text-align: center;\r\n\r\n            img {\r\n                max-width: 100%;\r\n                max-height: 240px;\r\n            }\r\n        }\r\n\r\n        .FileUploadContainer {\r\n            width: auto;\r\n        }\r\n\r\n        .button-block {\r\n            margin: 0 30px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
